import React, { memo, useContext } from 'react';
import { Avatar, Tooltip } from '@mui/material';
import { MessageContext } from '../chat-messages';

type MessageAvatarProps = {
    isMe?: boolean;
    avatar: string;
    name: string | undefined;
    family: string | undefined;
    route: string;
    style?: any;
    label?: string[];
};

const MessageAvatar = ({
    isMe,
    avatar,
    name,
    family,
    route,
    style,
}: MessageAvatarProps) => {
    const messageHook = useContext(MessageContext);
    const { onStringAvatar } = messageHook!;

    const onUserProfile = () => {
        window.open(route, '_blank');
    };

    return (
        <Tooltip
            title={name || family ? (name ?? 'نام') + ' ' + (family ?? '') : ''}
            placement={isMe ? 'top-start' : 'top-end'}
            arrow>
            <Avatar
                src={avatar}
                sx={{
                    width: 36,
                    height: 36,
                    cursor: !!route && 'pointer',
                    fontSize: 14,
                    mr: !isMe ? 0 : 1,
                    ml: !isMe ? 1 : 0,
                    ...style,
                }}
                onClick={() => !!route && onUserProfile()}
                {...onStringAvatar(
                    name ? name : 'نام',
                    family ? family : undefined,
                )}
            />
        </Tooltip>
    );
};

export default memo(MessageAvatar);
